import { GridColumnModel } from '../utils/common-interface';

export const unsyncOrderGridColumns: GridColumnModel[] = [
    {
        id: 1,
        name: 'Order',
        isChecked: true,
        map: 'cart_no',
        method: 'parseunsyncorder',
        hasRedirect: true,
        redirectTo: 'order-view'
    },
    {
        id: 2,
        name: 'Date',
        isChecked: true,
        map: 'created_at',
        method: 'formatMomentDate'
    },
    {
        id: 3,
        name: 'Store Name',
        isChecked: true,
        map: 'store_name'
    },
    {
        id: 4,
        name: 'Carrier',
        isChecked: true,
        map: 'shipping_method',
        method: 'parseMultiWarehouseCarrier'
    },
    {
        id: 4,
        name: 'Product Units',
        isChecked: true,
        map: 'total_units'
    },
    {
        id: 5,
        name: 'Amount',
        isChecked: true,
        map: 'total'
    },
    {
        id: 6,
        name: 'Event Type',
        isChecked: true,
        map: 'event_type'
    },
    {
        id: 7,
        name: 'Syncing Time',
        isChecked: true,
        map: 'syncing_time',
        method: 'formatMomentDate'
    },
    {
        id: 8,
        name: 'Syncing Error',
        isChecked: true,
        map: 'error_message'
    },
    {
        id: 9,
        name: 'Remark',
        isChecked: true,
        map: 'remarks'
    },
    {
        id: 10,
        name: 'Actions',
        isChecked: true,
        method: 'parseAction'
    }
];

export const unsyncProductGridColumns: GridColumnModel[] = [
    {
        id: 1,
        name: 'Channel SKU',
        isChecked: true,
        map: 'sku'
    },
    {
        id: 2,
        name: 'Product Name',
        isChecked: true,
        map: 'product_name'
    },
    {
        id: 3,
        name: 'Store Name',
        isChecked: true,
        map: 'store_name'
    },
    {
        id: 4,
        name: 'Product ID',
        isChecked: true,
        map: 'oms_item_id'
    },
    {
        id: 5,
        name: 'Variation Product ID',
        isChecked: true,
        map: 'oms_variantion_id'
    },
    {
        id: 6,
        name: 'Marketplace Product ID',
        isChecked: true,
        map: 'parent_item_id'
    },
    {
        id: 7,
        name: 'Marketplace Variation Product ID',
        isChecked: true,
        map: 'variantion_id'
    },
    {
        id: 8,
        name: 'Created On',
        isChecked: true,
        map: 'created_at',
        method: 'formatMomentDate'
    },
    {
        id: 9,
        name: 'Remark',
        isChecked: true,
        map: 'titleized_error_type',
        method: 'parseErrorType'
    },
    {
        id: 10,
        name: 'Comment',
        isChecked: true,
        method: 'parseAction'
    }
];

export const unsyncProductOfflineGridColumns: GridColumnModel[] = [
    {
        id: 1,
        name: 'Product Name',
        isChecked: true,
        map: 'product_name',
        method: 'parseCheckNull'
    },
    {
        id: 2,
        name: 'SKU',
        isChecked: true,
        map: 'sku',
        method: 'parseCheckNull'
    },

    {
        id: 3,
        name: 'Warehouse',
        isChecked: true,
        map: 'warehouse_code',
        method: 'parseCheckNull'
    },
    {
        id: 4,
        name: 'Created On',
        isChecked: true,
        map: 'created_at',
        method: 'formatMomentDate'
    },
    {
        id: 5,
        name: 'Remark',
        isChecked: true,
        method: 'parseUnsyncMessage'
    },
    {
        id: 6,
        name: 'Comment',
        isChecked: true,
        map: 'message',
        method: 'parseCheckNull'
    }
];
